enum modalState {
    Initial,
    Pending,
    Success,
    Error
}

export {modalState};